import type { SuggestionRow } from "./aggregate-proposals"
import { isApiRow } from "./aggregate-proposals"

// A row whose every proposal belongs to an open Agent card is reviewed on the
// Agent page, so the Docs sidebar and its badge leave it out.
export function withoutAgentOwnedRows(
	rows: SuggestionRow[],
	ownedGroupIds: ReadonlySet<string>,
): SuggestionRow[] {
	if (ownedGroupIds.size === 0) return rows
	return rows.filter(
		(row) =>
			!row.proposals.every(
				(p) =>
					p.proposalGroupId !== null && ownedGroupIds.has(p.proposalGroupId),
			),
	)
}

// Where the Agent page exists it reviews every suggestion except API and MCP
// drafts, which stay on the Docs page.
export function docsPageRows(
	rows: SuggestionRow[],
	ownedGroupIds: ReadonlySet<string>,
	agentShown: boolean,
): SuggestionRow[] {
	if (agentShown) return rows.filter(isApiRow)
	return withoutAgentOwnedRows(rows, ownedGroupIds)
}
